var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.88894 11.6662H8.55561M3.88894 8.55512H8.55561M3.88894 5.44401H4.66672M11.6667 5.44401L7.00005 0.777344H3.26672C2.39553 0.777344 1.95993 0.777344 1.62718 0.946891C1.33448 1.09602 1.09651 1.33399 0.94738 1.62669C0.777832 1.95944 0.777832 2.39504 0.777832 3.26623V12.2885C0.777832 13.1596 0.777832 13.5953 0.94738 13.928C1.09651 14.2207 1.33448 14.4587 1.62718 14.6078C1.95993 14.7773 2.39553 14.7773 3.26672 14.7773H9.17783C10.049 14.7773 10.4847 14.7773 10.8174 14.6078C11.1101 14.4587 11.3481 14.2207 11.4972 13.928C11.6667 13.5953 11.6667 13.1596 11.6667 12.2885V5.44401ZM7.00005 0.777344V4.19957C7.00005 4.63516 7.00005 4.85296 7.08483 5.01934C7.15942 5.16568 7.27834 5.28467 7.42472 5.35924C7.59109 5.44401 7.80887 5.44401 8.2445 5.44401H11.6667",
    stroke: "currentColor",
    strokeWidth: 1.55556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperDocument);
export default __webpack_public_path__ + "static/media/paper_document.4e2fe76f.svg";
export { ForwardRef as ReactComponent };